import { render, staticRenderFns } from "./MapWC.vue?vue&type=template&id=0c5870a8&scoped=true&shadow"
import script from "./MapWC.vue?vue&type=script&lang=ts&shadow"
export * from "./MapWC.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./MapWC.vue?vue&type=style&index=0&id=0c5870a8&prod&lang=less&shadow")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./MapWC.vue?vue&type=style&index=1&id=0c5870a8&prod&scoped=true&lang=less&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0c5870a8",
  null
  ,true
)

export default component.exports